import { Injectable, Renderer2, RendererFactory2, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private renderer: Renderer2;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public appendGtmScript(gtmId: string): void {
    if (environment.enableGTM && isPlatformBrowser(this.platformId)) {
      this.initializeDataLayer();

      // Crea el script de GTM
      const script: HTMLScriptElement = this.renderer.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

      // Encuentra el primer script en el documento para usarlo como referencia
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript) {
        this.renderer.insertBefore(document.head, script, firstScript);
      } else {
        // Si no hay ningún script, simplemente añade el script de GTM al head
        this.renderer.appendChild(document.head, script);
      }
    }
  }

  private initializeDataLayer(): void {
    const inlineScript = this.renderer.createText(`
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
    `);
    const scriptElem = this.renderer.createElement('script');
    this.renderer.appendChild(scriptElem, inlineScript);
    this.renderer.appendChild(document.head, scriptElem);
  }
}
